// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SupportCard_wrapper__77BWb","icon":"SupportCard_icon__HLGiP"};